import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import fr from "./fr.json";
import en from "./en.json";

// User-facing UI language. Source of truth = localStorage["delphi.locale"].
// Default: French. The diagnostic engine has an INDEPENDENT locale driven by
// the analyzed group's country (see backend `groupe.langue`).
const STORAGE_KEY = "delphi.locale";
const stored = typeof window !== "undefined" ? window.localStorage.getItem(STORAGE_KEY) : null;
const initial = stored === "en" ? "en" : "fr";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
    },
    lng: initial,
    fallbackLng: "fr",
    interpolation: { escapeValue: false },
    returnNull: false,
  });

i18n.on("languageChanged", (lng) => {
  if (typeof window !== "undefined") {
    window.localStorage.setItem(STORAGE_KEY, lng);
  }
});

export default i18n;
